import { faFile, faFileExcel, faImage } from '@fortawesome/free-regular-svg-icons';
import { faAngleDown, faAngleUp, faArrowDown, faArrowUp, faCloudArrowUp, faFilePdf, faPencil, faPlus, faSearch, faSort, faTimesCircle, faTrash, faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import React, { Component } from 'react';
import { Button, ButtonGroup, Card, Col, Container, Dropdown, Form, Image, Modal, Row, Spinner } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import { connect } from 'react-redux';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { toast } from 'react-toastify';
import XLSX from 'sheetjs-style';
import { GET, POST } from '../../api';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { handleFormErrors } from '../../helpers/form_helpers';
import { t } from '../../helpers/translation_helper';
import Header from '../_partials/Header/_Header';
import NavBar from '../_partials/NavBar/_NavBar';
import Pagination from '../_partials/Pagination';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
let cancelToken;

class Services extends Component {

  searchFieldRef = React.createRef();

  servicesTypes = [
    { value: 0, label: 'Service' },
    { value: 1, label: 'Inventory' },
    { value: 2, label: 'Resources' },
    { value: 3, label: 'Assets' },
  ];

  taxExempt = [
    { value: 0, label: 'Not Exempted' },
    { value: 1, label: 'Tax Exempt' },
  ];

  depTypes = [
    { value: 'month', label: 'Months' },
    { value: 'year', label: 'Year' },
  ];

  defaultFormFields = {
    services_id: 0,
    services_name: '',
    services_bundle: null,
    services_fee: '',
    services_cost: '',
    services_type: 0,
    services_vat: '',
    expats_only: 0,
    tax_exempt: 0,
    chapt_id: '',
    acc_num: '',
    qb_account: '',
    cogs_chapt_id: '',
    stock_chapt_id: '',
    cogs_chapt_id_disabled: false,
    stock_chapt_id_disabled: false,
    services_moq: '',
    services_desc: '',
    sad_purchase_date: '',
    sad_purchase_price: '',
    sad_warranty_expire: '',
    sad_useful_life: '',
    sad_residual_value: '',
    sad_serial_number: '',
    sad_depreciation_type: '',
    sad_depreciation_rate: '',
    cloc_id: '',
    barcode: '',
    services_image: '',
    services_image_prev: '',
    services_attachment: '',
    services_attachment_prev: '',
  }

  state = {
    ...this.defaultFormFields,
    isEditing: false,
    working: false,
    cdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'services.services_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'services.services_id',
          column: 'services_id',
          name: 'Actions',
          sortable: true
        },
        {
          id: 'services.services_name',
          column: 'services_name',
          name: 'Name',
          sortable: true
        },
        {
          id: 'services.services_fee',
          column: 'services_fee',
          name: 'Fee',
          sortable: true
        },
        {
          id: 'services.services_desc',
          column: 'services_desc',
          name: 'Description',
          sortable: true
        },
        {
          id: 'services.acc_num',
          column: 'acc_num',
          name: 'Account',
          sortable: true
        },
        {
          id: 'chapters.chapt_desc',
          column: 'chapt_desc',
          name: 'Chart',
          sortable: true
        },
        {
          id: 'services.services_type',
          column: 'services_type',
          name: 'Type',
          sortable: true
        },
        {
          id: 'services.services_vat',
          column: 'services_vat',
          name: 'VAT',
          sortable: true
        },
        {
          id: 'services.services_cost',
          column: 'services_cost',
          name: 'Cost',
          sortable: true
        },
        {
          id: 'services.qb_account',
          column: 'qb_account',
          name: '3rd Part Account',
          sortable: true
        },
        {
          id: 'services.tax_exempt',
          column: 'tax_exempt',
          name: 'Tax Exempt',
          sortable: true
        },
        {
          id: 'services.barcode',
          column: 'barcode',
          name: 'Barcode',
          sortable: true
        },
      ],
      data: [],
    },
    showFormModal: false,
    chapters: [],
    cogs: [],
    stocks: [],
    assetLocations: [],
    ddl_services_bundles: [],
  }

  services_image = React.createRef();
  services_attachment = React.createRef();


  componentDidMount() {
    const {
      search,
      rows: limit,
      order,
      dir
    } = this.state.cdt;
    this.fetch({ search: search, limit: limit, order: order, dir: dir, page: 0 })
    this.getSetDDLs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.authData.centerData.center_id !== this.props.authData.centerData.center_id) {
      this.fetch({ search: '', limit: 10, order: 'services.services_id', dir: 'DESC', page: 0 })
      this.getSetDDLs();
    }
  }

  getSetDDLs = async () => {

    try {
      const response = await axios.all([
        GET('services/get-chapters'),
        GET('services/get-chapters-cogs'),
        GET('services/get-chapters-stock'),
        GET('services/get-center-locations'),
        GET('services/get-services-bundles'),
      ]);

      // Chapters
      const chapters = response[0].data.map((item) => {
        return {
          value: item.chapt_id,
          label: item.chapt_desc,
        }
      });

      // COGS
      const cogs = response[1].data.map((item) => {
        return {
          value: item.chapt_id,
          label: item.chapt_desc,
        }
      });

      // Stocks
      const stocks = response[2].data.map((item) => {
        return {
          value: item.chapt_id,
          label: item.chapt_desc,
        }
      });

      // Asset Locations
      const assetLocations = response[3].data.map((item) => {
        return {
          value: item.cloc_id,
          label: item.cloc_name,
        }
      });

      // Services Bundles
      const ddl_services_bundles = response[4].data.map((item) => {
        return {
          value: item.services_bundle,
          label: item.services_bundle,
        }
      });

      this.setState({
        chapters,
        cogs,
        stocks,
        assetLocations,
        ddl_services_bundles,
      });

    } catch (err) {
      console.log('err', err)

    }


  }

  fetch = async ({ search, limit, order, dir, page }) => {

    this.setState({
      cdt: {
        ...this.state.cdt,
        fetching: true,
      }
    });

    if (cancelToken) {
      cancelToken.abort();
    }
    cancelToken = new AbortController();

    try {
      const res = await GET('services/get', {
        signal: cancelToken.signal,
        params: {
          search,
          order,
          dir,
          limit,
          offset: parseInt(page) * parseInt(limit)
        },
      });

      if (res.status === 200) {
        this.setState({
          cdt: {
            ...this.state.cdt,
            fetching: false,
            search,
            rows: parseInt(limit),
            offset: parseInt(page) * parseInt(limit),
            order,
            dir,
            page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(parseInt(res.data.total_count_filtered) / parseInt(limit)),
            data: res.data.data,
          }
        });
      }

    } catch (err) {
      console.log('err', err)
      this.setState({
        cdt: {
          ...this.state.cdt,
          fetching: false,
        }
      });

    }
  }


  handleOpenFormModal = () => {
    this.setState({
      showFormModal: true
    });
  }

  handleCloseFormModal = () => {
    this.setState({
      showFormModal: false,
      isEditing: false,
      ...this.defaultFormFields
    });
  }

  saveUpdate = async () => {

    const { authData } = this.props;
    const { center_id } = authData.centerData;

    this.setState({ working: true });

    let {
      services_id,
      services_name,
      services_fee,
      services_cost,
      services_type,
      services_vat,
      expats_only,
      tax_exempt,
      chapt_id,
      acc_num,
      qb_account,
      cogs_chapt_id,
      stock_chapt_id,
      services_moq,
      services_desc,
      sad_purchase_date,
      sad_purchase_price,
      sad_warranty_expire,
      sad_useful_life,
      sad_residual_value,
      sad_serial_number,
      sad_depreciation_type,
      sad_depreciation_rate,
      cloc_id,
      barcode,
      services_image,
      services_attachment,
      services_bundle,
      ddl_services_bundles
    } = this.state;
    if (services_bundle) {
      services_bundle = services_bundle.value
      if (!ddl_services_bundles.find((v) => v.value == services_bundle)) {
        ddl_services_bundles.push({ value: services_bundle, label: services_bundle })
      }
    } else {
      services_bundle = null
    }
    if (!cogs_chapt_id) {
      toast.error(t('COGS Account is required!'));
      this.setState({ working: false });
      return;
    }

    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('services_id', services_id);
    fData.append('ServicesData', JSON.stringify({
      services_name,
      services_bundle,
      services_fee,
      services_cost: services_cost ? services_cost : 0,
      services_type,
      services_vat: services_vat ? services_vat : 0,
      expats_only,
      tax_exempt,
      chapt_id: chapt_id.value,
      acc_num,
      qb_account,
      cogs_chapt_id: cogs_chapt_id ? cogs_chapt_id.value : 0,
      stock_chapt_id: stock_chapt_id ? stock_chapt_id.value : 0,
      services_moq,
      services_desc,
      barcode
    }));
    if (services_type == 3) {
      fData.append('ServiceAssetDetail', JSON.stringify({
        sad_purchase_date,
        sad_purchase_price,
        sad_warranty_expire,
        sad_useful_life,
        sad_residual_value,
        sad_serial_number,
        sad_depreciation_type: sad_depreciation_type?.value,
        sad_depreciation_rate,
        cloc_id: cloc_id?.value,
      }));
    }
    fData.append('services_image', services_image);
    fData.append('services_attachment', services_attachment);

    try {
      const res = await POST('services/save', fData);
      if (res) {
        let resData = res.data
        if (resData.type) {
          this.setState({ working: false });
          toast.success(t(res.data.message));
          this.fetch({ search: '', limit: this.state.cdt.rows, order: this.state.cdt.order, dir: this.state.cdt.dir, page: 0 });
          this.handleCloseFormModal();
        } else {
          // toast.error(t(res.data.message));
          handleFormErrors(res.data.data)
          this.setState({ working: false });
        }
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }

  }

  edit = (data) => {

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    this.setState({
      ...this.state,
      ...data,
      chapt_id: { value: data.chapt_id, label: data.chapt_desc },
      cogs_chapt_id: this.getSelectValue(data.cogs_chapt_id, 'cogs'),
      stock_chapt_id: this.getSelectValue(data.stock_chapt_id, 'stocks'),
      cogs_chapt_id_disabled: data.cogs_chapt_id != 0,
      stock_chapt_id_disabled: data.stock_chapt_id != 0,
      sad_depreciation_type: data.sad_depreciation_type ? ({ value: data.sad_depreciation_type, label: data.sad_depreciation_type.charAt(0).toUpperCase() + data.sad_depreciation_type.slice(1) }) : null,
      services_bundle: (data.services_bundle) ? { label: data.services_bundle, value: data.services_bundle } : null,
      cloc_id: data.cloc_id ? this.getSelectValue(data.cloc_id, 'assetLocations') : null,
      isEditing: true,
      services_image: data.services_image ? data.services_image : '',
      services_image_prev: regionalStorageURL + this.props.authData.centerData.center_uuid + '/services/' + data.services_image,
      services_attachment: data.services_attachment ? data.services_attachment : '',
      services_attachment_prev: regionalStorageURL + this.props.authData.centerData.center_uuid + '/services/' + data.services_attachment,
    }, () => {
      this.handleOpenFormModal();
    });
  }

  delete = async (v) => {
    const { authData } = this.props;
    const { center_id } = authData.centerData;

    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('services_id', v.services_id);

    try {
      const res = await POST('services/delete', fData);
      if (res.data.type) {
        toast.success(t(res.data.message));
        this.fetch({ search: this.state.cdt.search, limit: this.state.cdt.rows, order: this.state.cdt.order, dir: this.state.cdt.dir, page: this.state.cdt.page });
      } else {
        toast.error(t(res.data.message));
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }
  }

  getSelectValue = (value, list) => {
    if (value != 0) {
      return {
        value,
        label: this.state[list].find(item => item.value == value).label
      };
    } else {
      return null
    }
  }

  exportExcel = async () => {

    const excelData = this.state.cdt.data.map((item) => {
      const row = {};
      this.state.cdt.columns
        .filter((column) => column.visibility)
        .map((column) => {
          if (column.name !== 'Actions') {
            row[column.name] = item[column.column];
          }
        });
      return row;
    });

    const fileName = 'Services Export ' + moment().format('DD-MM-YYYY');
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(excelData);

    const cellStyle = {
      font: {
        bold: true,
      },
    }

    Array.from('ABCEFGHIJ').map((letter) => {
      ws[letter + "1"].s = cellStyle;
    });

    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
  }

  previewFile = (e) => {
    const reader = new FileReader();
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }
    reader.onload = (readerEvent) => {
      this.setState({
        [e.target.name + '_prev']: readerEvent.target.result,
        [e.target.name]: e.target.files[0],
      });
    };
  };

  render() {
    const { cdt, ddl_services_bundles } = this.state
    console.log('this.state', this.state, this.state.services_image.includes('.pdf'));

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('Services')} backBtn={true} showCenterSelector={true} />
            <div>
              <Card className='border-0' >
                <div className='d-flex flex-row align-items-center'>
                  <div className='px-1' style={{ flex: 1 }}>
                    <div className='cdt-search' style={{ height: 38, width: '100%', borderRadius: 20 }}>
                      <input
                        style={{
                          paddingLeft: 17
                        }}
                        type='text'
                        ref={this.searchFieldRef}
                        defaultValue={this.state.cdt.search}
                        onChange={(e) =>
                          this.fetch({
                            search: e.target.value,
                            limit: this.state.cdt.rows,
                            order: this.state.cdt.order,
                            dir: this.state.cdt.dir,
                            page: 0,
                          })
                        }
                        placeholder={t('Search...')}
                      />
                      <button
                        onClick={() => {
                          this.fetch({
                            search: '',
                            limit: this.state.cdt.rows,
                            order: this.state.cdt.order,
                            dir: this.state.cdt.dir,
                            page: 0,
                          });
                          this.searchFieldRef.current.value = '';
                        }}>
                        <FontAwesomeIcon
                          icon={this.state.cdt.search == '' ? faSearch : faXmark}
                          color={
                            brand_colors[this.props.defaultTheme.theme_id].color18
                          }
                        />
                      </button>
                    </div>
                  </div>
                  <div className='d-flex flex-row align-items-center px-1'>
                    <div className='me-2' style={{ display: 'inline-block' }}>
                      <Dropdown>
                        <Dropdown.Toggle variant="light"
                          style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}>
                          {t('Show:') + ' ' + (this.state.cdt.rows == -1 ? 'All' : this.state.cdt.rows)}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {this.state.cdt.rowsOptions.map((row, index) =>
                            <Dropdown.Item onClick={() => this.fetch({
                              search: this.state.cdt.search,
                              limit: row,
                              order: this.state.cdt.order,
                              dir: this.state.cdt.dir,
                              page: this.state.cdt.page,
                            })
                            }
                              key={index}>{row == -1 ? 'All' : row}</Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className='me-2' style={{ display: 'inline-block' }}>
                      <Dropdown>
                        <Dropdown.Toggle variant='light'
                          style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }} className='crm-options-btn'>
                          <FontAwesomeIcon
                            icon={faSort}
                            style={{ fontSize: 13, marginRight: 5 }}
                          />{t('Sort')}
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ width: 180 }}>
                          {this.state.cdt.columns
                            .filter(column => column.sortable)
                            .map((column, index) => {
                              return (
                                <Dropdown.Item
                                  onClick={() => this.fetch({
                                    search: this.state.cdt.search,
                                    limit: this.state.cdt.rows,
                                    order: column.id,
                                    dir: (this.state.cdt.order == column.id) ? cdt.dir == 'ASC' ? 'DESC' : 'ASC' : 'DESC',
                                    page: this.state.cdt.page,
                                  })}
                                  className='d-flex justify-content-between align-items-center'>
                                  {t(column.name)}
                                  {this.state.cdt.order == column.id &&
                                    <FontAwesomeIcon
                                      icon={this.state.cdt.dir == 'DESC' ? faArrowDown : faArrowUp}
                                      style={{ fontSize: 12 }}
                                    />}
                                </Dropdown.Item>
                              )
                            })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <button
                      onClick={() => this.exportExcel()}
                      style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}
                      className='btn btn-light btn-sm me-2'>
                      <FontAwesomeIcon
                        icon={faFileExcel}
                        style={{ marginRight: 5 }}
                      />
                      {t('Excel')}
                    </button>
                    <button
                      onClick={this.handleOpenFormModal}
                      style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}
                      className='btn btn-info btn-sm'>
                      <FontAwesomeIcon
                        icon={faPlus}
                        color={
                          brand_colors[this.props.defaultTheme.theme_id].color8
                        }
                        style={{ fontSize: 15 }}
                      /> {t('Add')}
                    </button>
                  </div>
                </div>
                <Card.Body style={{ paddingTop: 8 }}>
                  <Row>
                    {this.state.cdt.fetching && (
                      <Col
                        md={12}
                        className='py-5 d-flex flex-column align-items-center'>
                        <Spinner as='span' animation='grow' size='sm' />{' '}
                        {t('Loading Data')}
                      </Col>
                    )}
                    {!this.state.cdt.fetching && this.state.cdt.data.length === 0 && (
                      <Col
                        md={12}
                        className='py-5 d-flex flex-column align-items-center'>
                        {t('No Data Found')}
                      </Col>
                    )}

                    {!this.state.cdt.fetching && this.state.cdt.data.length !== 0 &&
                      <Col md={12} className='grey-section p-2' style={{ borderRadius: 10 }}>
                        {this.state.cdt.data.map((v, i) => {
                          let this_servicesTypes = this.servicesTypes.find((vv) => vv.value == v.services_type)
                          return <div className='d-flex flex-column align-items-center my-1 p-1' style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 5 }}>
                            <div className='d-flex flex-row' style={{ width: '100%', fontSize: 14 }}>
                              <div className='d-flex flex-row px-2 align-items-center' style={{ flex: 1 }}>
                                <Image src={(v.services_image)
                                  ? regionalStorageURL + this.props.authData.centerData.center_uuid + '/services/' + v.services_image
                                  : require('../../assets/images/placeholder150.png')} style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 5 }} />
                                <div className='d-flex flex-column p-2' style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 600 }}>Name</div>
                                  <div>{v.services_name}</div>
                                </div>
                                <div className='d-flex flex-column p-2' style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 600 }}>Type</div>
                                  <div>{this_servicesTypes.label}</div>
                                </div>
                                <div className='d-flex flex-column p-2' style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 600 }}>Fee</div>
                                  <div>{v.services_fee}</div>
                                </div>
                                <div className='d-flex flex-column p-2' style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 600 }}>VAT</div>
                                  <div>{v.services_vat}</div>
                                </div>
                                <div className='d-flex flex-column p-2' style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 600 }}>Cost</div>
                                  <div>{v.services_cost}</div>
                                </div>
                                <div className='d-flex flex-column p-2' style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 600 }}>Account</div>
                                  <div>{v.acc_num}</div>
                                </div>
                                <div className='d-flex flex-column p-2' style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 600 }}>Chart</div>
                                  <div>{v.chapt_desc}</div>
                                </div>
                              </div>
                            </div>
                            <div className='d-flex flex-column px-3 my-3' style={{ width: '100%', fontSize: 14 }}>
                              <div style={{ fontWeight: 600 }}>Description</div>
                              <div>{v.services_desc}</div>
                            </div>
                            <div className='d-flex flex-row align-items-center justify-content-between p-2' style={{ width: '100%' }}>
                              <div>
                                <Button
                                  onClick={() => this.delete(v)}
                                  variant='danger'
                                  size='sm'
                                  className='me-1'>
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                                <Button
                                  onClick={() => this.edit(v)}
                                  variant='warning'
                                  size='sm'
                                  className='me-1'>
                                  <FontAwesomeIcon icon={faPencil} />
                                </Button>
                              </div>
                              <div className='d-flex flex-row justify-content-end' style={{ flex: 1 }}>
                                {v.barcode &&
                                  <div className='d-flex flex-row align-items-center badge badge-light-primary me-1'>
                                    <div>Barcode: </div>
                                    <div>{v.barcode}</div>
                                  </div>
                                }
                                {(v.tax_exempt) ?
                                  <div className='d-flex flex-row align-items-center badge badge-light-danger me-1'>
                                    <div>Tax Exempt</div>
                                  </div>
                                  : null
                                }
                                {(v.services_attachment) &&
                                  <div className='d-flex flex-row align-items-center me-1 badge badge-light-light cursor-pointer' onClick={() => window.open(regionalStorageURL + this.props.authData.centerData.center_uuid + '/services/' + v.services_attachment)}>
                                    <FontAwesomeIcon icon={faFile} />
                                    <div className='ms-1'>{t('Attachment')}</div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        })}
                      </Col>
                    }
                  </Row>
                  <Pagination
                    pageCount={this.state.cdt.lastPage || 1}
                    forcePage={this.state.cdt.page}
                    callbackParams={{
                      search: this.state.cdt.search,
                      limit: this.state.cdt.rows,
                      order: this.state.cdt.order,
                      dir: this.state.cdt.dir,
                    }}
                    callback={this.fetch}
                  />
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
        <Modal size='xl' show={this.state.showFormModal} onHide={this.handleCloseFormModal} backdrop="static" keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.isEditing ? t('Edit') : t('Add')} {t('Service')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='custom-styled-form'>
            <div className='d-flex flex-row'>
              <div className='pe-2' style={{ flex: 1 }}>

                <div className='d-flex flex-row align-items-center mb-2'>
                  <div className='pe-4'>
                    <ButtonGroup size='sm'>
                      {this.servicesTypes.map((item, index) => (
                        <Button key={index} variant={(this.state.services_type == item.value) ? 'primary' : 'light'} onClick={(e) => this.setState({ services_type: item.value })} >{t(item.label)}</Button>
                      ))}
                    </ButtonGroup>
                  </div>
                  <div className='pe-4'>
                    <ButtonGroup size='sm'>
                      {this.taxExempt.map((item, index) => (
                        <Button key={index} variant={(this.state.tax_exempt == item.value) ? 'primary' : 'light'} onClick={(e) => this.setState({ tax_exempt: item.value })} >{t(item.label)}</Button>
                      ))}
                    </ButtonGroup>
                  </div>
                  <div className='pe-2'>
                    <Form.Check
                      className='primary'
                      label={t('Expats Only')}
                      onChange={() => this.setState({ expats_only: this.state.expats_only == 1 ? 0 : 1 })}
                      checked={this.state.expats_only == 1}
                    />
                  </div>
                </div>
                <div className='d-flex flex-row align-items-center mb-3'>
                  <div style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('Bundle')}</Form.Label>
                      <Creatable
                        isClearable
                        classNamePrefix='custom-styled-select'
                        placeholder={t('Type new or Select')}
                        value={this.state.services_bundle}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (
                            base
                          ) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={this.state.ddl_services_bundles}
                        onChange={(obj) => this.setState({ services_bundle: obj })}
                      />
                    </Form.Group>
                  </div>
                  <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                    <div className={'alert alert-warning mb-0'}>{t('You can create a bundle of services to use it in Marketplace.')}</div>
                  </div>
                </div>
                <div className='d-flex flex-row mb-3'>
                  <div className='me-4' style={{ flex: 1.5 }}>
                    <Form.Group >
                      <Form.Label>{t('Name')}</Form.Label>
                      <Form.Control type="text"
                        defaultValue={this.state.services_name}
                        onBlur={(e) => this.setState({ services_name: e.target.value })} />
                    </Form.Group>
                  </div>
                  <div className='me-2' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('Barcode')}</Form.Label>
                      <Form.Control type="text"
                        defaultValue={this.state.barcode}
                        onBlur={(e) => this.setState({ barcode: e.target.value })}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className='d-flex flex-row mb-3'>
                  <div className='me-4' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('Fee')}</Form.Label>
                      <Form.Control type="text"
                        defaultValue={this.state.services_fee}
                        onBlur={(e) => this.setState({ services_fee: e.target.value })}
                        placeholder='0.00'
                      />
                    </Form.Group>
                  </div>
                  <div className='me-4' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('Cost')}</Form.Label>
                      <Form.Control type="text"
                        defaultValue={this.state.services_cost}
                        onBlur={(e) => this.setState({ services_cost: e.target.value })}
                        placeholder='0.00'
                      />
                    </Form.Group>
                  </div>
                  <div className='me-2' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('VAT')}</Form.Label>
                      <Form.Control type="text"
                        defaultValue={this.state.services_vat}
                        onBlur={(e) => this.setState({ services_vat: e.target.value })}
                        placeholder='0.00'
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className='d-flex flex-row mb-3'>
                  <div className='me-4' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('Chart')}</Form.Label>
                      <Select
                        classNamePrefix='custom-styled-select'
                        value={this.state.chapt_id}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (
                            base
                          ) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={this.state.chapters}
                        onChange={(obj) => this.setState({ chapt_id: obj })}
                        isDisabled={this.state.isEditing}
                      />
                    </Form.Group>
                  </div>
                  <div className='me-4' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('Account')}</Form.Label>
                      <Form.Control type="text"
                        defaultValue={this.state.acc_num}
                        onBlur={(e) => this.setState({ acc_num: e.target.value })}
                        readOnly
                        placeholder={t('Auto-Generate')}
                      />
                    </Form.Group>
                  </div>
                  <div className='me-2' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('3rd Party Account')}</Form.Label>
                      <Form.Control type="text"
                        defaultValue={this.state.qb_account}
                        onBlur={(e) => this.setState({ qb_account: e.target.value })}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className='d-flex flex-row mb-3'>
                  <div className='me-4' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('COGS Account')}</Form.Label>
                      <Select
                        classNamePrefix='custom-styled-select'
                        value={this.state.cogs_chapt_id}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (
                            base
                          ) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={this.state.cogs}
                        onChange={(obj) => this.setState({ cogs_chapt_id: obj })}
                        isDisabled={this.state.cogs_chapt_id_disabled}
                      />
                    </Form.Group>
                  </div>
                  <div className='me-4' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('Stock Account')}</Form.Label>
                      <Select
                        classNamePrefix='custom-styled-select'
                        value={this.state.stock_chapt_id}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (
                            base
                          ) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={this.state.stocks}
                        onChange={(obj) => this.setState({ stock_chapt_id: obj })}
                        isDisabled={this.state.stock_chapt_id_disabled}
                      />
                    </Form.Group>
                  </div>
                  <div className='me-2' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('MOQ')}</Form.Label>
                      <Form.Control type="text"
                        defaultValue={this.state.services_moq}
                        onBlur={(e) => this.setState({ services_moq: e.target.value })}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className='d-flex flex-row '>
                  <div className='me-2' style={{ flex: 1 }}>
                    <Form.Group >
                      <Form.Label>{t('Description')}</Form.Label>
                      <Form.Control as="textarea" rows={3}
                        defaultValue={this.state.services_desc}
                        onBlur={(e) => this.setState({ services_desc: e.target.value })}
                      />
                    </Form.Group>
                  </div>
                </div>

                {this.state.services_type == 3 &&
                  <>
                    <div className='d-flex flex-row mt-3 mb-3'>
                      <h5 className='mb-0'>{t('Assets Details')}</h5>
                    </div>
                    <div className='d-flex flex-row mb-3'>
                      <div className='me-4' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Purchase Date')}</Form.Label>
                          <Flatpickr
                            className='form-control'
                            value={this.state.sad_purchase_date}
                            onChange={([
                              date,
                            ]) => {
                              this.setState(
                                {
                                  sad_purchase_date:
                                    moment(
                                      date
                                    ).format(
                                      'YYYY-MM-DD'
                                    ),
                                }
                              );
                            }}
                          />
                        </Form.Group>
                      </div>
                      <div className='me-4' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Purchase Price')}</Form.Label>
                          <Form.Control type="text"
                            defaultValue={this.state.sad_purchase_price}
                            onBlur={(e) => this.setState({ sad_purchase_price: e.target.value })}
                            placeholder='0.00'
                          />
                        </Form.Group>
                      </div>
                      <div className='me-2' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Warranty Expiry Date')}</Form.Label>
                          <Flatpickr
                            className='form-control'
                            value={this.state.sad_warranty_expire}
                            onChange={([
                              date,
                            ]) => {
                              this.setState(
                                {
                                  sad_warranty_expire:
                                    moment(
                                      date
                                    ).format(
                                      'YYYY-MM-DD'
                                    ),
                                }
                              );
                            }}
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <div className='d-flex flex-row mb-3'>
                      <div className='me-4' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Useful Life (Months)')}</Form.Label>
                          <Form.Control type="number"
                            defaultValue={this.state.sad_useful_life}
                            onChange={(e) => this.setState({ sad_useful_life: e.target.value })}
                            min={0}
                          />
                        </Form.Group>
                      </div>
                      <div className='me-4' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Residual Value')}</Form.Label>
                          <Form.Control type="text"
                            defaultValue={this.state.sad_residual_value}
                            onBlur={(e) => this.setState({ sad_residual_value: e.target.value })}
                          />
                        </Form.Group>
                      </div>
                      <div className='me-2' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Serial Number')}</Form.Label>
                          <Form.Control type="text"
                            defaultValue={this.state.sad_serial_number}
                            onBlur={(e) => this.setState({ sad_serial_number: e.target.value })}
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <div className='d-flex flex-row mb-3'>
                      <div className='me-4' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Depreciation Type')}</Form.Label>
                          <Select
                            value={this.state.sad_depreciation_type}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (
                                base
                              ) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            options={this.depTypes}
                            onChange={(obj) => this.setState({ sad_depreciation_type: obj })}
                          />
                        </Form.Group>
                      </div>
                      <div className='me-4' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Depreciation Rate')}</Form.Label>
                          <Form.Control type="text"
                            defaultValue={this.state.sad_depreciation_rate}
                            onBlur={(e) => this.setState({ sad_depreciation_rate: e.target.value })}
                          />
                        </Form.Group>
                      </div>
                      <div className='me-2' style={{ flex: 1 }}>
                        <Form.Group >
                          <Form.Label>{t('Location of Asset')}</Form.Label>
                          <Select
                            value={this.state.cloc_id}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (
                                base
                              ) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            options={this.state.assetLocations}
                            onChange={(obj) => this.setState({ cloc_id: obj })}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </>
                }
              </div>
              <div className='d-flex flex-column ps-2' >
                <div className='mb-3'>
                  <Form.Group >
                    <Form.Label>{t('Image')}</Form.Label>
                    <div style={{ flexDirection: 'column', }} className='pic-prev d-flex justify-content-center'>
                      <div
                        style={{
                          borderRadius: 5,
                          borderStyle: 'dashed',
                          borderWidth: 2,
                          borderColor: '#969696',
                          height: 200,
                          width: 200,
                          display: 'flex',
                          overflow: 'hidden',
                          backgroundColor: '#fafafa'
                        }}>
                        {this.state.services_image !== '' &&
                          this.state.services_image_prev !== '' ? (
                          <div className='d-flex justify-content-center align-items-center text-center'
                            style={{ flex: 1, position: 'relative', }}>
                            <button
                              style={{ padding: 3, border: 3, background: 'none', position: 'absolute', top: 0, right: 0, }}
                              onClick={() => {
                                this.setState({ services_image: '', services_image_prev: '', });
                                this.services_image.current.value = null;
                              }}>
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                color='rgb(220, 53, 69)'
                                style={{ fontSize: 20, }}
                              />
                            </button>
                            <a href={this.state.services_image_prev} target='_blank'>
                              {(this.state.services_image && (this.state.services_image.includes('.pdf') || this.state.services_image?.type?.includes('pdf')))
                                ? <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 20, color: brand_colors[this.props.defaultTheme.theme_id].color11 }} />
                                : <img
                                  src={this.state.services_image_prev}
                                  alt={t('Preview')}
                                  style={{ width: 200, height: 200, objectFit: 'cover' }}
                                />
                              }
                            </a>
                          </div>
                        ) : (
                          <button
                            onClick={() => this.services_image.current.click()}
                            style={{ background: 'none', border: 0, flex: 1, }}>
                            <FontAwesomeIcon icon={faCloudArrowUp} style={{ fontSize: 25, color: '#0a121f' }} />
                          </button>
                        )}
                      </div>
                      <Form.Control
                        className='d-none'
                        ref={this.services_image}
                        type='file'
                        onChange={this.previewFile}
                        name='services_image'
                        accept='.jpg, .jpeg, .png'
                      />
                    </div>
                  </Form.Group>
                </div>
                <div>
                  <Form.Group >
                    <Form.Label>{t('Attachment')}</Form.Label>
                    <div style={{ flexDirection: 'column', }} className='pic-prev d-flex justify-content-center'>
                      <div
                        style={{
                          borderRadius: 5,
                          borderStyle: 'dashed',
                          borderWidth: 2,
                          borderColor: '#969696',
                          height: 200,
                          width: 200,
                          display: 'flex',
                          overflow: 'hidden',
                          backgroundColor: '#fafafa'
                        }}>
                        {this.state.services_attachment !== '' &&
                          this.state.services_attachment_prev !== '' ? (
                          <div
                            className='d-flex justify-content-center align-items-center text-center'
                            style={{ flex: 1, position: 'relative', }}>
                            <button
                              style={{ padding: 3, border: 3, background: 'none', position: 'absolute', top: 0, right: 0, }}
                              onClick={() => {
                                this.setState({ services_attachment: '', services_attachment_prev: '', });
                                this.services_attachment.current.value = null;
                              }}>
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                color='rgb(220, 53, 69)'
                                style={{ fontSize: 20, }}
                              />
                            </button>
                            <a href={this.state.services_attachment_prev} target='_blank'>
                              {(this.state.services_attachment && (this.state.services_attachment.includes('.pdf') || this.state.services_attachment?.type?.includes('pdf')))
                                ? <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 20, color: brand_colors[this.props.defaultTheme.theme_id].color11 }} />
                                : <img
                                  src={this.state.services_attachment_prev}
                                  alt={t('Preview')}
                                  style={{ width: 200, height: 200, objectFit: 'cover' }}
                                />
                              }
                            </a>
                          </div>
                        ) : (
                          <button
                            onClick={() => this.services_attachment.current.click()}
                            style={{ background: 'none', border: 0, flex: 1, }}>
                            <FontAwesomeIcon icon={faCloudArrowUp} style={{ fontSize: 25, color: '#0a121f' }} />
                          </button>
                        )}
                      </div>
                      <Form.Control className='d-none' ref={this.services_attachment} type='file' onChange={this.previewFile} name='services_attachment' accept='.jpg, .jpeg, .png, .pdf'
                      />
                    </div>
                  </Form.Group>
                </div>
              </div>
            </div>



          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseFormModal}>
              {t('Close')}
            </Button>
            <Button disabled={this.state.working} variant='success' onClick={() => this.saveUpdate()}>
              {t('Save')} {this.state.working ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' /> : ''}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container >
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(Services);
